/* eslint-disable @typescript-eslint/no-floating-promises */

import React from 'react'
import Image from 'next/image'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { SEGMENT } from '@components/MainWidget/common/widgetSegments'
import { getProductName } from '@components/MainWidget/ChallanWidgetLanding/helper'
import { DynamicCouponBanner } from './DynamicCouponBanner'
import { getDaysUntilPolicyExpires, getMessageTemplate, vehicleType } from './helper'
import { UNABLE_TO_PROCESS_PNG } from './constants'
import styles from './whatsappChallan.module.scss'

interface RewardSectionWidgetProps {
  proposalData: any
  vehicleData: any
  redirectUrl: string
  amount: number
  segmentEventCommonProperties: any
  regNo: string
  phone: string
}

const RewardSectionWidget: React.FC<RewardSectionWidgetProps> = ({
  vehicleData,
  proposalData,
  redirectUrl,
  amount,
  segmentEventCommonProperties,
  regNo,
  phone,
}) => {
  const whichVehicle = vehicleType(vehicleData) || 'car'
  const days = getDaysUntilPolicyExpires(proposalData?.previous_policy_expiry_date)
  const { prefix, highlight, suffix } = getMessageTemplate(days)

  const handleOnClick = () => {
    trackEvent(SEGMENT.TAP_BTN, {
      ...segmentEventCommonProperties,
      product: getProductName(),
      registration_number: regNo,
      phone,
      journey: 'challan',
    })
    window.location.href = redirectUrl
  }

  return (
    <div className={styles.connectBannerWithImage}>
      <div className={styles.insuranceExpBanner}>
        <Image width={40} height={40} src={UNABLE_TO_PROCESS_PNG} alt="Unable to process" />
        <p className={styles.expiryText}>
          Your {whichVehicle.toLowerCase()} insurance {prefix && <span>{prefix} </span>}
          <span className={styles.expiryHighlight}>{highlight}</span>
          {suffix && <span> {suffix}</span>}
        </p>
        <p className={styles.expirySubText}>Renew now to stay protected</p>
        <button type="button" onClick={handleOnClick} className={styles.primaryButtonForExpBanner}>
          Check your special price
        </button>
      </div>
      <div className={styles.renewalIconContainer}>
        <DynamicCouponBanner amount={amount} />
      </div>
    </div>
  )
}

export default RewardSectionWidget
